import { FunctionComponent } from "react"
import Card from "@mui/material/Card"
import CardContent from "@mui/material/CardContent"
import Typography from "@mui/material/Typography"
import Grid from "@mui/material/Grid"
import { RunModelDtoWrapper } from "@store/services/modelsService"
import { Link } from "react-router"
import { IconButton, Tooltip } from "@mui/material"
import { ArrowOutward } from "@mui/icons-material"
import { TypeOfBlock } from "@features/home/RecentActivityBlock"

interface Props {
  runModels: RunModelDtoWrapper
}

export const RunModelList: FunctionComponent<Props> = ({ runModels }) => {
  return (
    <div>
      <Grid container spacing={3}>
        {runModels.items.map((m, i) => (
          <Grid item xs={4} key={`option-${i}`}>
            <Link to={`/Run/ViewModel/${m.key}`}>
              <Card
                sx={{
                  minWidth: 275,
                  backgroundColor: "#FAF9F6",
                  boxShadow: 0,
                  "&:hover": { boxShadow: 20 },
                  borderLeft: "4px solid #6986b0",
                }}
              >
                <CardContent>
                  <Grid container wrap="nowrap" justifyContent="space-between">
                    <Grid item>
                      <Typography
                        variant={"body1"}
                        sx={{
                          textTransform: "uppercase",
                          color: "gray",
                          fontSize: 9,
                        }}
                      >
                        {TypeOfBlock.MODEL.valueOf()}
                      </Typography>
                    </Grid>

                    <Grid item>
                      <Tooltip title="Go to base graph">
                        <Link to={`/ScenarioDesign?graphKey=${encodeURIComponent(m.graph_key)}`}>
                          <IconButton aria-label="Base graph link">
                            <ArrowOutward sx={{ color: "grey" }} />
                          </IconButton>
                        </Link>
                      </Tooltip>
                    </Grid>
                  </Grid>

                  <Typography variant="h5" sx={{ fontWeight: 600 }}>
                    {m.description}
                  </Typography>
                  <Typography sx={{ fontSize: "24px", fontWeight: 600 }} gutterBottom>
                    {m.graph_key}
                  </Typography>
                  <Typography variant="h5" component="div">
                    <b>{m.dimensions.country}</b> {m.scenario_key}
                  </Typography>
                  <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    Parameter set: {m.parameters}
                  </Typography>
                </CardContent>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </div>
  )
}
